import en from './en.json'
import it from './it.json'

export const policiesTranslations = {
	en,
	it
} as const
